import React from 'react'
import TabView from '../components/TabView'

const CutTab = ({tab, data}) => <TabView tab={tab} data={data}/>

export default CutTab
